import { watch } from 'vue'
import store from '../store'
import routes from '../constants/routes'

export default () => {

  const getComponent = () => {
    const currentRoute = routes.find(i => i.name == store.state.currentRoute)
    if (currentRoute) {
      return currentRoute.component
    }
  }

  const getRoute = () => {
    return store.state.currentRoute
  }

  const getAppProps = (name) => {
    if (typeof name != 'undefined')
      return store.state.appProps[name]

    return store.state.appProps
  }

  const getRouteParams = (name) => {
    if (typeof name != 'undefined') {
      return (store.state.routeProps[name] != 'undefined')
        ? store.state.routeProps[name]
        : ''
    }
        
    return store.state.routeProps
  }

  const setAppProps = props => {
    store.commit('setAppProps', props)
  }

  const setRouteParams = props => {
    store.commit('setRouteProps', props)
  }

  const show = (name, props) => {
    store.commit('setRoute', name)
    if (typeof props != 'undefined') {
      setRouteParams(props)
    }
  }

  const watchRouteParams = (name, callback) => {
    watch(() => store.state.routeProps[name], v => {
      callback(v)
    })
  }

  return {
    getComponent,
    getRoute,
    getAppProps,
    getRouteParams,
    setAppProps,
    setRouteParams,
    watchRouteParams,
    show,
  }

}
